export const colors = {
  bg: '#111111',
  bgAlt: '#171717',
  surface: '#1d1d1d',
  surfaceHover: '#242424',
  border: 'rgba(255, 255, 255, 0.10)',
  borderStrong: 'rgba(255, 255, 255, 0.24)',
  text: '#f5f5f5',
  textMuted: 'rgba(255, 255, 255, 0.72)',
  textSubtle: 'rgba(255, 255, 255, 0.52)',
  white: '#ffffff',
  black: '#0a0a0a',
  whatsapp: '#25D366',
  star: '#f5b301',
  // Brand orange sampled from the logo mark.
  accent: '#FC6A01',
  accentHover: '#E25F00',
  accentSoft: 'rgba(252, 106, 1, 0.14)',
};

export const fonts = {
  heading: '"Playfair Display", Georgia, serif',
  body: '"Inter", "Helvetica Neue", Arial, sans-serif',
};

// Strings on purpose: numeric borderRadius in MUI `sx` is multiplied by theme.shape.borderRadius.
export const radii = {
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  pill: '999px',
};

export const shadows = {
  card: '0 10px 30px rgba(0, 0, 0, 0.35)',
  cardHover: '0 18px 44px rgba(0, 0, 0, 0.5)',
  nav: '0 8px 24px rgba(0, 0, 0, 0.35)',
};

export const layout = {
  navHeight: 72,
  navHeightCompact: 64,
  mobileBarHeight: 64,
};

export const business = {
  name: 'Behson Property Solutions',
  phoneDisplay: '+44 7988 682 289',
  phoneHref: 'tel:+447988682289',
  email: 'Behson@live.com',
  emailHref: 'mailto:Behson@live.com',
  whatsappHref:
    'https://api.whatsapp.com/send/?phone=447988682289&text&type=phone_number&app_absent=0',
  instagramHref: 'https://www.instagram.com/behsonuk/',
  instagramHandle: '@behsonuk',
  areaShort: 'Kingsbury, NW9 & North West London',
};
